import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import LogoSecondStep from '../../components/appSettings/logoTwo';
import VersionBox from '../../components/common/VersionBox';
import ImageCropper from '../../components/common/imageCropper';
import YesNoDialog from '../../components/common/YesNoDialog';
import constants from '../../constants';
import PreviewLogo from '../../components/preview/PreviewLogo';
import ImageDropZone from '../../components/common/ImageDropZone';
import i18n from '../../i18n';
import FullScreenModal from '../modals/FullScreenModal';

class Logo extends React.Component {
    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.setFile = this.setFile.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.switchToSizes = this.switchToSizes.bind(this);
        this.switchToUpload = this.switchToUpload.bind(this);
        this.displayWarning = this.displayWarning.bind(this);
        this.clearWarning = this.clearWarning.bind(this);
        this.switchToCrop = this.switchToCrop.bind(this);
        this.closeYesNoDialog = this.closeYesNoDialog.bind(this);
        this.proceedLogoUpload = this.proceedLogoUpload.bind(this);

        this.props = props;

        this.state = {
            imageLocation: '',
            modalIsOpen: false,
            file: '',
            originalHeight: 0,
            originalWidth: 0,
            aspectRatio: null,
            cropperView: 0,
        };
    }

    componentDidMount() {
        if (typeof this.props.versions?.select?.logoImage?.imagePath !== 'undefined') this.switchToSizes();
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.resetWarning();
        this.props.actions.resetCroppedImage();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.crop.modal !== prevProps.crop.modal && this.props.crop.modal === true) {
            this.switchToCrop();
        } else if (this.props.crop.hasCroppedImage !== prevProps.crop.hasCroppedImage
            || this.props.crop.wrongResolution !== prevProps.crop.wrongResolution) {
            if (this.props.crop.hasCroppedImage === false
                && this.props.crop.wrongResolution === true) {
                this.displayWarning();
            } else if (this.props.crop.hasCroppedImage === false
                && this.props.crop.wrongResolution === false) {
                this.switchToUpload();
            } else if (this.props.crop.hasCroppedImage === true) {
                this.switchToSizes();
            }
        }
        if (prevState.showUpload && this.props.crop.hasCroppedImage) {
            this.switchToSizes();
        }
        if (prevState.modalIsOpen
            && !this.state.modalIsOpen
            && this.props.crop.hasCroppedImage === false
            && !this.props.versions?.select?.logoImage?.imagePath) {
            this.switchToUpload();
        }
        if (!this.props.versions.inProgress && prevProps.versions.inProgress) {
            if (typeof this.props.versions?.select?.logoImage?.imagePath === 'undefined') this.switchToUpload();
            else this.switchToSizes();
        }
    }

    componentWillUnmount() {
        this.props.actions.resetImageData();
    }

    setFile(file) {
        this.setState({ file });
    }

    clearWarning() {
        this.props.actions.clearAlert('wrongSize');
    }

    displayWarning() {
        const id = 'wrongSize';
        if (this.props.alerts.data.filter((n) => { return n.id === id; }).length === 0) {
            this.props.actions.addAlert({
                message: `${i18n.t('logo.error1')} ${constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinWidth} px x ${constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinHeight} px`,
                clearable: true,
                clearAction: this.clearWarning,
                type: 'error',
                view: 'logo',
                id,
            });
        }
    }

    switchToUpload() {
        this.setState({
            modalIsOpen: false,
            cropperView: 0,
        });
    }

    switchToSizes() {
        this.setState({
            modalIsOpen: false,
            cropperView: 2,
        });
    }

    switchToCrop() {
        this.setState({
            modalIsOpen: true,
            cropperView: 1,
            originalHeight: 0,
            originalWidth: 0,
        });
    }

    openModal(image) {
        this.setState({
            imageLocation: image.imageLocation,
            modalIsOpen: true,
            cropperView: 1,
            originalHeight: image.height,
            originalWidth: image.width,
        });
        this.clearWarning();
    }

    closeModal() {
        if (this.props.versions?.select?.logoImage?.imagePath === 'undefined') {
            this.setState({
                modalIsOpen: false,
                cropperView: 0,
                imageLocation: '',
            });
        }
        this.setState({
            modalIsOpen: false,
            cropperView: 2,
            imageLocation: this.props.versions?.select?.logoImage?.imagePath,
        });
    }

    proceedLogoUpload() {
        // this.state.tmpButton.click();
        this.setState({
            dialogOpened: false,
            increaseMajorVersion: true,
        });
    }

    closeYesNoDialog() {
        const stateObj = {};
        stateObj.dialogOpened = false;
        this.setState(stateObj);
    }

    render() {
        const logoPath = typeof this.props.versions?.select?.logoImage?.imagePath === 'undefined' ? this.state.imageLocation : this.props.versions?.select?.logoImage?.imagePath;
        let address = '';
        if (this.props.versions.select) {
            address = `${this.props.versions.select.churchStreetAddress || ''} ${this.props.versions.select.churchCity || ''}, ${this.props.versions.select.churchState || ''} ${this.props.versions.select.churchZip || ''}`;
        }
        const previewLogo = (<PreviewLogo address={address} description={this.props.versions.select ? this.props.versions.select.description : ''} logo={logoPath} church={this.props.versions.select && typeof this.props.versions.select.churchName !== 'undefined' ? this.props.versions.select.churchName : ''} />);
        const form = (
            <div className="form-wrapper">
                <h1 data-qa="logo-page-header">{i18n.t('logo.header')}</h1>
                {this.state.cropperView === 0 && (
                    <div className="firstStep" data-qa="logo-page-upload-screen-wrapper">
                        <p className="lead" data-qa="logo-page-subhad-upload-screen">{i18n.t('logo.subtitle')}</p>
                        <p className="help-text text-center" data-qa="logo-upload-help-text">
                            {i18n.t('logo.help1')}
                            {' '}
                            {constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinWidth}
                            {' '}
                            x
                            {' '}
                            {constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinHeight}
                            px
                            {' '}
                            {i18n.t('logo.help2')}
                            <br />
                            {i18n.t('logo.help3')}
                        </p>
                        <ImageDropZone imageType="Logo" setFile={this.setFile} height="372" width="372" hasError={this.props.crop.wrongResolution} />
                    </div>
                )}

                {this.state.cropperView === 2 && (
                    <div className="secondStep" data-qa="logo-page-two-wrapper">
                        <LogoSecondStep
                            data={this.state}
                            imageType={constants.ImageType.find((n) => { return n.Name === 'Logo'; }).Id}
                            imagePath={logoPath}
                            switchBackToStart={this.switchBackToStart}
                            switchBackToCrop={this.switchBackToCrop}
                        />
                    </div>
                )}

                {this.state.modalIsOpen && this.state.cropperView === 1 && (
                    <div className="cropTool" data-qa="crop-page-wrapper">
                        <FullScreenModal
                            visible={this.state.modalIsOpen}
                            close={this.closeModal}
                            dataqa={i18n.t('crop')}
                        >
                            <h2 id="modal-title" data-qa="modal-title" className="modal-title">Crop Your Logo</h2>
                            <ImageCropper
                                width="50"
                                height="50"
                                cropperWidth={250}
                                cropperHeight={250}
                                borderRadius={500}
                                aspect={this.state.aspectRatio}
                                onClose={this.closeModal}
                                image={this.state.imageLocation}
                                imageName={this.state.file.name}
                                imageType={constants.ImageType.find((n) => { return n.Name === 'Logo'; }).Id}
                                isOriginal
                                originalHeight={this.state.originalHeight}
                                originalWidth={this.state.originalWidth}
                                switchToSizes={this.switchToSizes}
                                increaseMajorVersion={this.state.increaseMajorVersion}
                                projVersion={this.props.versions.select}
                                minHeight={constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinHeight}
                                minWidth={constants.ImageType.find((n) => { return n.Name === 'Logo'; }).MinWidth}
                            />
                        </FullScreenModal>
                    </div>
                )}
            </div>
        );
        return (
            <div>
                <VersionBox
                    name={this.props.versions.select ? this.props.versions.select.name : ''}
                    versionNumber={this.props.versions.select ? this.props.versions.select.version : ''}
                    saving={this.props.versions.inProgress
                        || this.props.versions.validationInProgress}
                    justSaved={this.props.projects.justSaved}
                    menuSection="AppSettings"
                    menuItem="Logo"
                    previewCssClass="app-settings_logo"
                    previewChild={previewLogo}
                    configCode={this.props.versions.select ? this.props.versions.select.configCode : ''}
                    x
                >
                    <div className="content-inside">
                        {form}
                    </div>
                    <YesNoDialog
                        Message={i18n.t('logo.confirm')}
                        ExecuteAction={this.proceedLogoUpload}
                        CloseDialog={this.closeYesNoDialog}
                        Visible={this.state.dialogOpened}
                    />
                </VersionBox>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        versions: state.versions,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
